// Mapbox configuration
// IMPORTANT: Only use public tokens (pk.) in client-side code!
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibWFrZW5vaXNlbWVkaWEiLCJhIjoiY2xvZGtmdW53MDdxYjJqcGw3ZTNlNGlxMyJ9.dGhAeNbJqE5Sb1xy6eRrgw'; 

export { MAPBOX_ACCESS_TOKEN }; 